import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container, Typography } from '@mui/material';
import { wrapperSx } from '@/global/helpers/globalstyles';
import PageHeader from '@/global/components/PageHeader';
import { CityLinksSection, SchoolsCatalogMain } from '@/modules/schools';

function AutoSchoolCatalogPage() {
    return (
        <Box
            className="App"
            sx={{height: '100%', display: 'flex', flexDirection: 'column'}}
        >
            <PageHeader/>
            <Helmet>
                <title>
                    Каталог автошкол Казахстана
                    {' '}
                    - Найдите лучшую автошколу
                </title>
                <meta
                    name="description"
                    content={`Полный каталог автошкол Казахстана. Актуальные контакты, категории обучения A, B, C, D, адреса и телефоны автошкол. Выберите автошколу для получения водительских прав.`}
                />
                <meta
                    name="keywords"
                    content={`автошколы Казахстан, водительские права, обучение вождению, категории A B C D, автошкола рядом`}
                />
                <meta
                    property="og:title"
                    content={`Каталог автошкол Казахстана`}
                />
                <meta
                    property="og:description"
                    content={`Выберите автошколу для обучения в Казахстане. Актуальные контакты и категории обучения.`}
                />
                <meta
                    property="og:type"
                    content="website"
                />
                <link
                    rel="canonical"
                    href={`${window.location.origin}/catalog`}
                />
            </Helmet>

            <Container
                maxWidth="xl"
                sx={wrapperSx}
            >
                <Box sx={{pt: 4, pb: 3}}>
                    <Typography
                        variant="h1"
                        component="h1"
                        sx={{
                            fontSize: {xs: '2rem', md: '2.5rem'},
                            fontWeight: 'bold',
                            color: '#2c3e50',
                            textAlign: 'center',
                            mb: 2
                        }}
                    >
                        Каталог автошкол Казахстана
                    </Typography>

                    <Typography
                        variant="h2"
                        component="p"
                        sx={{
                            fontSize: {xs: '1.1rem', md: '1.25rem'},
                            color: '#5a6c7d',
                            textAlign: 'center',
                            maxWidth: '800px',
                            mx: 'auto',
                            lineHeight: 1.6
                        }}
                    >
                        Найдите лучшую автошколу в любом городе Казахстана. Все категории обучения: A, B, C, D.
                        Актуальные контакты и адреса.
                    </Typography>
                </Box>

                <CityLinksSection/>

                <SchoolsCatalogMain/>

            </Container>
        </Box>
    );
}

export default AutoSchoolCatalogPage;
